export default function isNullish<T>(
  x: T | null | undefined
): x is null | undefined {
  return x == null;
}
